export default async function initModalAuthByPhone(selector) {
    const modal = document.querySelector(selector);

    if (!modal) return;

    const {
        default: initModalAuthByPhone,
        ModalAuthPhone
    } = await import('../legacy/modal-auth-by-phone.desktop');

    Vue.component('modal-auth-phone', ModalAuthPhone);
    initModalAuthByPhone(modal);
}
